import { ArchiveIcon } from '@radix-ui/react-icons'
import { FiGithub } from 'react-icons/fi'
import type { IconType as BaseIconType } from 'react-icons/lib'
import {
	MdArrowBack,
	MdArrowDownward,
	MdArrowDropDown,
	MdArrowForward,
	MdArrowRightAlt,
	MdArrowUpward,
	MdAttachMoney,
	MdAutoAwesome,
	MdBolt,
	MdChangeHistory,
	MdChevronLeft,
	MdChevronRight,
	MdClose,
	MdDescription,
	MdDownloading,
	MdDragIndicator,
	MdErrorOutline,
	MdExpandLess,
	MdExpandMore,
	MdFolder,
	MdFolderZip,
	MdInventory2,
	MdIosShare,
	MdMenu,
	MdMoreHoriz,
	MdOutlineAccountBalance,
	MdOutlineAccountCircle,
	MdOutlineAdd,
	MdOutlineAddLink,
	MdOutlineArrowOutward,
	MdOutlineAssuredWorkload,
	MdOutlineAttachEmail,
	MdOutlineAttachFile,
	MdOutlineAttachMoney,
	MdOutlineAutoAwesome,
	MdOutlineBlock,
	MdOutlineBrokenImage,
	MdOutlineCalculate,
	MdOutlineCalendarMonth,
	MdOutlineCategory,
	MdOutlineClear,
	MdOutlineConfirmationNumber,
	MdOutlineContentCopy,
	MdOutlineCropFree,
	MdOutlineDarkMode,
	MdOutlineDashboardCustomize,
	MdOutlineEditNote,
	MdOutlineEmail,
	MdOutlineEqualizer,
	MdOutlineFace,
	MdOutlineFactCheck,
	MdOutlineFilterList,
	MdOutlineForwardToInbox,
	MdOutlineGraphicEq,
	MdOutlineGridView,
	MdOutlineHistory,
	MdOutlineInfo,
	MdOutlineInsights,
	MdOutlineInventory2,
	MdOutlineLanguage,
	MdOutlineLaunch,
	MdOutlineLeaderboard,
	MdOutlineLightMode,
	MdOutlineLink,
	MdOutlineListAlt,
	MdOutlineMoreTime,
	MdOutlineMoreVert,
	MdOutlineNotificationsNone,
	MdOutlineOpenInNew,
	MdOutlinePalette,
	MdOutlinePictureAsPdf,
	MdOutlinePieChart,
	MdOutlinePlayArrow,
	MdOutlineQrCode2,
	MdOutlineReceiptLong,
	MdOutlineRefresh,
	MdOutlineReorder,
	MdOutlineRepeat,
	MdOutlineShowChart,
	MdOutlineSignpost,
	MdOutlineSquareFoot,
	MdOutlineStackedBarChart,
	MdOutlineStar,
	MdOutlineStop,
	MdOutlineStyle,
	MdOutlineSubdirectoryArrowLeft,
	MdOutlineSyncAlt,
	MdOutlineTask,
	MdOutlineThumbDown,
	MdOutlineThumbUp,
	MdOutlineTune,
	MdOutlineVisibility,
	MdOutlineVolumeOff,
	MdOutlineVolumeUp,
	MdOutlineWidgets,
	MdPictureAsPdf,
	MdPlayArrow,
	MdRefresh,
	MdSearch,
	MdSnippetFolder,
	MdSort,
	MdStop,
	MdTrendingDown,
	MdTrendingUp,
} from 'react-icons/md'
import { PiDiscordLogo } from 'react-icons/pi'

type SVGIconProps = {
	size?: number
	stroke?: string
	fill?: string
	strokeWidth?: number
	className?: string
	children?: React.ReactNode
	viewBox?: string
}

export type IconType = BaseIconType

const SVGIcon: React.FC<SVGIconProps> = ({
	size = 20,
	stroke = 'currentColor',
	fill = 'currentColor',
	strokeWidth = 0.25,
	className,
	children,
	viewBox,
}) => {
	const intrinsicContentDimension = 20
	const defaultViewBox = `0 0 ${intrinsicContentDimension} ${intrinsicContentDimension}`

	return (
		<svg
			width={size}
			height={size}
			viewBox={viewBox || defaultViewBox}
			fill={fill}
			stroke={stroke}
			strokeWidth={strokeWidth}
			strokeLinecap='round'
			strokeLinejoin='round'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
		>
			{children}
		</svg>
	)
}

const Icons = {
	LogoSmall: (props: SVGIconProps) => (
		<SVGIcon size={28} {...props} viewBox='0 0 479 479'>
			<path
				fill='currentColor'
				clipRule='evenodd'
				fillRule='evenodd'
				d='M112.797 301.059C182.125 353.055 218.582 417.602 227.547 469h25.101c4.184-25.699 15.54-53.789 34.664-84.27C325.562 324.367 402.66 265.199 469 251.453v-25.101c-32.871-7.172-65.145-22.114-96.223-44.227C309.426 137.301 262.809 70.363 252.648 10h-25.101c-5.977 31.676-19.723 62.156-41.238 93.234C143.875 164.793 77.535 210.215 10 226.352v25.101c34.066 7.172 68.73 23.906 102.797 49.606'
			/>
		</SVGIcon>
	),
	Logo: (props?: SVGIconProps) => (
		<>
			<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 865 300' width={113} height={32} fill='none' {...props}>
				<path
					fill='#1c4f4a'
					fillRule='evenodd'
					d='M717.929 96.902c15.79 11.842 24.093 26.543 26.135 38.249h5.717c.952-5.853 3.539-12.25 7.894-19.192 8.712-13.748 26.271-27.224 41.38-30.355v-5.717c-7.486-1.633-14.836-5.036-21.915-10.073-14.428-10.208-25.045-25.454-27.359-39.202h-5.717c-1.362 7.215-4.492 14.157-9.393 21.235-9.664 14.02-24.773 24.365-40.155 28.04v5.717c7.759 1.634 15.654 5.445 23.413 11.298'
					clipRule='evenodd'
				/>
				<path
					fill='currentColor'
					d='M184.244 73.034c3.273 0 5.182 1.091 5.182 3.273v.546c0 2.18-1.835 3.49-3.96 5.01-2.926 2.09-6.404 4.575-6.404 10.261l-.272 104.993c-.273 53.724-24.816 71.996-57.814 72.269-41.452.272-56.724-27.544-56.724-43.907 0-7.635 4.636-12.544 11.727-12.544 9.466 0 12.271 8.314 15.477 17.817 4.274 12.67 9.261 27.453 31.701 27.453 17.181 0 31.089-16.636 31.089-49.634V92.124c0-5.686-3.384-8.171-6.233-10.262-2.07-1.518-3.857-2.83-3.857-5.01v-.545c0-2.182 2.182-3.273 5.727-3.273z'
				/>
				<path
					fill='currentColor'
					fillRule='evenodd'
					d='M265.536 104.547c40.907 0 69.268 31.089 69.269 69.268 0 37.634-25.908 67.087-64.36 67.087-43.361 0-71.177-32.997-71.177-70.086 0-37.906 28.907-66.269 66.268-66.269m-2.726 9c-23.181 0-39.271 19.089-39.271 49.633 0 34.907 20.181 68.723 50.179 68.723 21.271 0 37.089-19.363 37.089-49.906 0-38.179-20.181-68.45-47.997-68.45'
					clipRule='evenodd'
				/>
				<path
					fill='currentColor'
					d='M462.339 105.638c4.635-.818 7.09-.273 7.09 3.272v105.813c0 12.211 5.746 13.751 10.189 14.942 2.8.751 5.083 1.363 5.083 4.42 0 4.636-5.455 5.726-16.908 5.727-12.272 0-20.454-4.909-19.908-20.181l-.546-1.636c-7.909 14.454-22.635 22.907-41.997 22.907-29.726 0-50.451-21.816-50.451-62.177v-48.27c0-6.21-3.624-8.992-6.528-11.223-1.942-1.491-3.563-2.736-3.563-4.594v-.819c0-1.909 1.636-3.545 4.091-4.09l22.908-4.091c4.635-.818 7.362-.273 7.362 3.272l-.272 71.724c0 31.634 11.454 49.632 32.179 49.633 19.363 0 34.635-16.363 34.635-41.453v-58.359c0-6.138-3.732-8.832-6.774-11.028-2.094-1.512-3.861-2.788-3.862-4.789v-.819c0-1.909 1.364-3.545 4.091-4.09zm167.796 0c5.181-2.727 7.636 0 7.636 4.091v19.908c7.908-15.272 23.725-25.09 42.542-25.09 26.726 0 49.088 17.999 51.815 60.269l3 53.724c.315 5.826 3.539 8.288 6.208 10.326 1.953 1.492 3.609 2.756 3.609 4.946v1.09c0 2.182-2.181 3.546-5.726 3.546h-32.453c-3.545 0-5.727-1.364-5.727-3.546v-1.09c0-2.156 1.795-3.416 3.851-4.858 2.885-2.024 6.285-4.409 5.966-10.142l-2.726-54.541c-1.364-33.271-14.727-49.088-33.544-49.088-20.18 0-34.089 16.09-34.089 37.633v66.27c0 5.495 3.616 7.827 6.685 9.805 2.26 1.457 4.224 2.723 4.224 4.921v1.09c0 2.182-2.182 3.546-5.727 3.546H611.59c-3.273 0-5.454-1.364-5.454-3.546v-1.09c0-2.198 1.914-3.464 4.118-4.921 2.991-1.978 6.517-4.31 6.517-9.805v-82.632c0-7.12-4.222-9.716-7.54-11.756-2.146-1.319-3.914-2.406-3.914-4.334v-.818c0-1.909 1.637-3 4.364-4.091zm-61.05-1.09c16.363 0 25.09 9.544 25.09 20.998 0 7.09-3.273 12.817-10.908 12.817-6.779 0-8.76-4.362-10.828-8.916-2.257-4.972-4.618-10.174-13.444-10.174-14.999 0-23.181 17.182-23.181 37.635v62.178c0 5.558 3.886 7.973 7.13 9.989 2.327 1.446 4.325 2.688 4.325 4.737v1.091c-.001 2.182-1.91 3.273-5.455 3.273h-33.816c-3.545 0-5.454-1.091-5.454-3.273v-1.091c0-2.049 1.76-3.291 3.81-4.737 2.858-2.016 6.28-4.431 6.28-9.989v-82.904c0-6.071-3.743-8.679-6.844-10.839-2.193-1.528-4.064-2.832-4.064-4.979v-.545c0-1.909 1.636-3.545 4.09-4.909l20.727-9.271c5.181-2.455 7.09-.273 7.09 3.817v21.817c5.999-17.453 18.544-26.725 35.452-26.725'
				/>
			</svg>
		</>
	),
	Apps: (props: SVGIconProps) => (
		<SVGIcon {...props}>
			<path d='M4.99936 16.3461C4.62922 16.3461 4.31235 16.2143 4.04874 15.9507C3.78513 15.687 3.65332 15.3702 3.65332 15C3.65332 14.6299 3.78513 14.313 4.04874 14.0494C4.31235 13.7858 4.62922 13.654 4.99936 13.654C5.3695 13.654 5.68638 13.7858 5.94999 14.0494C6.2136 14.313 6.3454 14.6299 6.3454 15C6.3454 15.3702 6.2136 15.687 5.94999 15.9507C5.68638 16.2143 5.3695 16.3461 4.99936 16.3461ZM9.99936 16.3461C9.62922 16.3461 9.31235 16.2143 9.04874 15.9507C8.78513 15.687 8.65332 15.3702 8.65332 15C8.65332 14.6299 8.78513 14.313 9.04874 14.0494C9.31235 13.7858 9.62922 13.654 9.99936 13.654C10.3695 13.654 10.6864 13.7858 10.95 14.0494C11.2136 14.313 11.3454 14.6299 11.3454 15C11.3454 15.3702 11.2136 15.687 10.95 15.9507C10.6864 16.2143 10.3695 16.3461 9.99936 16.3461ZM14.9994 16.3461C14.6292 16.3461 14.3123 16.2143 14.0487 15.9507C13.7851 15.687 13.6533 15.3702 13.6533 15C13.6533 14.6299 13.7851 14.313 14.0487 14.0494C14.3123 13.7858 14.6292 13.654 14.9994 13.654C15.3695 13.654 15.6864 13.7858 15.95 14.0494C16.2136 14.313 16.3454 14.6299 16.3454 15C16.3454 15.3702 16.2136 15.687 15.95 15.9507C15.6864 16.2143 15.3695 16.3461 14.9994 16.3461ZM4.99936 11.3461C4.62922 11.3461 4.31235 11.2143 4.04874 10.9507C3.78513 10.687 3.65332 10.3702 3.65332 10C3.65332 9.62989 3.78513 9.31302 4.04874 9.04941C4.31235 8.7858 4.62922 8.65399 4.99936 8.65399C5.3695 8.65399 5.68638 8.7858 5.94999 9.04941C6.2136 9.31302 6.3454 9.62989 6.3454 10C6.3454 10.3702 6.2136 10.687 5.94999 10.9507C5.68638 11.2143 5.3695 11.3461 4.99936 11.3461ZM9.99936 11.3461C9.62922 11.3461 9.31235 11.2143 9.04874 10.9507C8.78513 10.687 8.65332 10.3702 8.65332 10C8.65332 9.62989 8.78513 9.31302 9.04874 9.04941C9.31235 8.7858 9.62922 8.65399 9.99936 8.65399C10.3695 8.65399 10.6864 8.7858 10.95 9.04941C11.2136 9.31302 11.3454 9.62989 11.3454 10C11.3454 10.3702 11.2136 10.687 10.95 10.9507C10.6864 11.2143 10.3695 11.3461 9.99936 11.3461ZM14.9994 11.3461C14.6292 11.3461 14.3123 11.2143 14.0487 10.9507C13.7851 10.687 13.6533 10.3702 13.6533 10C13.6533 9.62989 13.7851 9.31302 14.0487 9.04941C14.3123 8.7858 14.6292 8.65399 14.9994 8.65399C15.3695 8.65399 15.6864 8.7858 15.95 9.04941C16.2136 9.31302 16.3454 9.62989 16.3454 10C16.3454 10.3702 16.2136 10.687 15.95 10.9507C15.6864 11.2143 15.3695 11.3461 14.9994 11.3461ZM4.99936 6.34607C4.62922 6.34607 4.31235 6.21427 4.04874 5.95066C3.78513 5.68705 3.65332 5.37017 3.65332 5.00003C3.65332 4.62989 3.78513 4.31302 4.04874 4.04941C4.31235 3.7858 4.62922 3.65399 4.99936 3.65399C5.3695 3.65399 5.68638 3.7858 5.94999 4.04941C6.2136 4.31302 6.3454 4.62989 6.3454 5.00003C6.3454 5.37017 6.2136 5.68705 5.94999 5.95066C5.68638 6.21427 5.3695 6.34607 4.99936 6.34607ZM9.99936 6.34607C9.62922 6.34607 9.31235 6.21427 9.04874 5.95066C8.78513 5.68705 8.65332 5.37017 8.65332 5.00003C8.65332 4.62989 8.78513 4.31302 9.04874 4.04941C9.31235 3.7858 9.62922 3.65399 9.99936 3.65399C10.3695 3.65399 10.6864 3.7858 10.95 4.04941C11.2136 4.31302 11.3454 4.62989 11.3454 5.00003C11.3454 5.37017 11.2136 5.68705 10.95 5.95066C10.6864 6.21427 10.3695 6.34607 9.99936 6.34607ZM14.9994 6.34607C14.6292 6.34607 14.3123 6.21427 14.0487 5.95066C13.7851 5.68705 13.6533 5.37017 13.6533 5.00003C13.6533 4.62989 13.7851 4.31302 14.0487 4.04941C14.3123 3.7858 14.6292 3.65399 14.9994 3.65399C15.3695 3.65399 15.6864 3.7858 15.95 4.04941C16.2136 4.31302 16.3454 4.62989 16.3454 5.00003C16.3454 5.37017 16.2136 5.68705 15.95 5.95066C15.6864 6.21427 15.3695 6.34607 14.9994 6.34607Z' />
		</SVGIcon>
	),
	Transactions: (props: SVGIconProps) => (
		<SVGIcon {...props}>
			<path d='M5.97685 13.9743H7.45122V12.5H5.97685V13.9743ZM5.97685 10.737H7.45122V9.26288H5.97685V10.737ZM5.97685 7.49996H7.45122V6.02558H5.97685V7.49996ZM9.24622 13.862H13.9898V12.6123H9.24622V13.862ZM9.24622 10.625H13.9898V9.37496H9.24622V10.625ZM9.24622 7.38767H13.9898V6.13788H9.24622V7.38767ZM2.91602 17.0833V2.91663H17.0827V17.0833H2.91602ZM4.16602 15.8333H15.8327V4.16663H4.16602V15.8333Z' />
		</SVGIcon>
	),
	Invoice: (props: SVGIconProps) => (
		<SVGIcon {...props}>
			<path d='M6.875 14.7916H13.125V13.5416H6.875V14.7916ZM6.875 11.4583H13.125V10.2083H6.875V11.4583ZM3.75 17.9166V2.08331H11.875L16.25 6.45831V17.9166H3.75ZM11.25 7.08331V3.33331H5V16.6666H15V7.08331H11.25Z' />
		</SVGIcon>
	),
	Vault: (props: SVGIconProps) => (
		<SVGIcon {...props}>
			<path d='M9.99967 12.7083C10.4045 12.7083 10.7488 12.5665 11.0326 12.2829C11.3162 11.9992 11.458 11.6549 11.458 11.25C11.458 10.8451 11.3162 10.5008 11.0326 10.2171C10.7488 9.93347 10.4045 9.79167 9.99967 9.79167C9.59481 9.79167 9.25051 9.93347 8.96676 10.2171C8.68315 10.5008 8.54134 10.8451 8.54134 11.25C8.54134 11.6549 8.68315 11.9992 8.96676 12.2829C9.25051 12.5665 9.59481 12.7083 9.99967 12.7083ZM2.08301 17.0833V5.41667H7.08301V2.5H12.9163V5.41667H17.9163V17.0833H2.08301ZM3.33301 15.8333H16.6663V6.66667H3.33301V15.8333ZM8.33301 5.41667H11.6663V3.75H8.33301V5.41667Z' />
		</SVGIcon>
	),
	Customers: (props: SVGIconProps) => (
		<SVGIcon {...props}>
			<path d='M14.0702 16.9871C13.2681 16.9871 12.5815 16.7015 12.0104 16.1304C11.4393 15.5592 11.1537 14.8725 11.1537 14.0704C11.1537 13.2683 11.4393 12.5817 12.0104 12.0106C12.5815 11.4395 13.2681 11.1539 14.0702 11.1539C14.8723 11.1539 15.5589 11.4395 16.1302 12.0106C16.7013 12.5817 16.9869 13.2683 16.9869 14.0704C16.9869 14.8725 16.7013 15.5592 16.1302 16.1304C15.5589 16.7015 14.8723 16.9871 14.0702 16.9871ZM14.0702 15.7371C14.5285 15.7371 14.9209 15.5739 15.2473 15.2475C15.5737 14.9211 15.7369 14.5287 15.7369 14.0704C15.7369 13.6121 15.5737 13.2197 15.2473 12.8933C14.9209 12.5669 14.5285 12.4037 14.0702 12.4037C13.6119 12.4037 13.2195 12.5669 12.8931 12.8933C12.5667 13.2197 12.4035 13.6121 12.4035 14.0704C12.4035 14.5287 12.5667 14.9211 12.8931 15.2475C13.2195 15.5739 13.6119 15.7371 14.0702 15.7371ZM5.92936 14.4871C5.12728 14.4871 4.44061 14.2015 3.86936 13.6304C3.29825 13.0592 3.0127 12.3725 3.0127 11.5704C3.0127 10.7683 3.29825 10.0817 3.86936 9.51061C4.44061 8.9395 5.12728 8.65395 5.92936 8.65395C6.73145 8.65395 7.41804 8.9395 7.98915 9.51061C8.56027 10.0817 8.84582 10.7683 8.84582 11.5704C8.84582 12.3725 8.56027 13.0592 7.98915 13.6304C7.41804 14.2015 6.73145 14.4871 5.92936 14.4871ZM5.92936 13.2371C6.3877 13.2371 6.78006 13.0739 7.10645 12.7475C7.43283 12.4211 7.59603 12.0287 7.59603 11.5704C7.59603 11.1121 7.43283 10.7197 7.10645 10.3933C6.78006 10.0669 6.3877 9.90374 5.92936 9.90374C5.47103 9.90374 5.07867 10.0669 4.75228 10.3933C4.42589 10.7197 4.2627 11.1121 4.2627 11.5704C4.2627 12.0287 4.42589 12.4211 4.75228 12.7475C5.07867 13.0739 5.47103 13.2371 5.92936 13.2371ZM9.16645 8.07686C8.36436 8.07686 7.67777 7.79131 7.10665 7.2202C6.5354 6.64895 6.24978 5.96228 6.24978 5.1602C6.24978 4.35811 6.5354 3.67152 7.10665 3.10041C7.67777 2.52916 8.36436 2.24353 9.16645 2.24353C9.96853 2.24353 10.6551 2.52916 11.2262 3.10041C11.7975 3.67152 12.0831 4.35811 12.0831 5.1602C12.0831 5.96228 11.7975 6.64895 11.2262 7.2202C10.6551 7.79131 9.96853 8.07686 9.16645 8.07686ZM9.16645 6.82686C9.62478 6.82686 10.0171 6.66367 10.3435 6.33728C10.6699 6.01089 10.8331 5.61853 10.8331 5.1602C10.8331 4.70186 10.6699 4.3095 10.3435 3.98311C10.0171 3.65672 9.62478 3.49353 9.16645 3.49353C8.70811 3.49353 8.31575 3.65672 7.98936 3.98311C7.66297 4.3095 7.49978 4.70186 7.49978 5.1602C7.49978 5.61853 7.66297 6.01089 7.98936 6.33728C8.31575 6.66367 8.70811 6.82686 9.16645 6.82686Z' />
		</SVGIcon>
	),
	Shortcut: (props: SVGIconProps) => (
		<SVGIcon {...props}>
			<path d='M3.667 13.5V6h7.418L8.62 3.546l.713-.713L13 6.5l-3.677 3.677-.703-.713L11.085 7H4.667v6.5h-1Z' />
		</SVGIcon>
	),
	Apple: (props: SVGIconProps) => (
		<SVGIcon {...props} viewBox='0 0 19 23'>
			<path
				fill='currentColor'
				d='M18.143 17.645a11.967 11.967 0 0 1-1.183 2.126c-.622.887-1.131 1.5-1.524 1.842-.608.56-1.26.846-1.958.862-.501 0-1.105-.143-1.809-.432-.706-.288-1.354-.43-1.947-.43-.622 0-1.29.142-2.003.43-.714.29-1.29.44-1.73.455-.67.029-1.337-.266-2.002-.885-.426-.371-.957-1.007-1.594-1.907-.683-.961-1.245-2.076-1.685-3.347C.236 14.986 0 13.656 0 12.369c0-1.474.319-2.746.957-3.811A5.612 5.612 0 0 1 2.96 6.53a5.39 5.39 0 0 1 2.71-.765c.531 0 1.228.165 2.095.488.863.324 1.418.489 1.661.489.182 0 .799-.192 1.843-.576.988-.355 1.822-.503 2.505-.445 1.851.15 3.242.88 4.166 2.194-1.655 1.003-2.474 2.408-2.458 4.21.015 1.404.524 2.572 1.525 3.5.454.43.96.763 1.524.999a16.56 16.56 0 0 1-.388 1.02ZM13.898.94c0 1.1-.402 2.128-1.204 3.079-.967 1.13-2.136 1.783-3.404 1.68a3.425 3.425 0 0 1-.026-.417c0-1.056.46-2.186 1.277-3.11.407-.469.926-.858 1.555-1.168.627-.306 1.22-.475 1.778-.504.017.147.024.294.024.44Z'
			/>
		</SVGIcon>
	),
	Google: (props: SVGIconProps) => (
		<SVGIcon {...props} viewBox='0 0 20 20' fill='none' strokeWidth={0}>
			<g clipPath='url(#a)'>
				<path
					d='M10 3.958c1.475 0 2.796.509 3.838 1.5l2.854-2.854C14.959.992 12.696 0 10 0a9.995 9.995 0 0 0-8.933 5.508l3.325 2.58c.787-2.371 3-4.13 5.608-4.13Z'
					fill='#EA4335'
				/>
				<path
					d='M19.575 10.23c0-.655-.063-1.288-.158-1.897H10v3.759h5.392a4.648 4.648 0 0 1-1.992 2.991l3.22 2.5c1.88-1.741 2.955-4.316 2.955-7.354Z'
					fill='#4285F4'
				/>
				<path
					d='M4.388 11.912A6.075 6.075 0 0 1 4.07 10c0-.667.112-1.308.317-1.913L1.063 5.508A9.964 9.964 0 0 0 0 10c0 1.617.383 3.142 1.067 4.492l3.32-2.58Z'
					fill='#FBBC05'
				/>
				<path
					d='M10 20c2.7 0 4.97-.887 6.62-2.42l-3.22-2.5c-.896.603-2.05.958-3.4.958-2.608 0-4.82-1.759-5.612-4.13l-3.325 2.58C2.712 17.758 6.091 20 10 20Z'
					fill='#34A853'
				/>
			</g>
			<defs>
				<clipPath id='a'>
					<path fill='currentColor' d='M0 0h20v20H0z' />
				</clipPath>
			</defs>
		</SVGIcon>
	),
	Microsoft: (props: SVGIconProps) => (
		<SVGIcon {...props} viewBox='0 0 21 21' fill='none' strokeWidth={0}>
			<rect x='1' y='1' width='9' height='9' fill='#F25022' />
			<rect x='11' y='1' width='9' height='9' fill='#7FBA00' />
			<rect x='1' y='11' width='9' height='9' fill='#00A4EF' />
			<rect x='11' y='11' width='9' height='9' fill='#FFB900' />
		</SVGIcon>
	),
	InboxCustomize: (props?: SVGIconProps) => (
		<svg xmlns='http://www.w3.org/2000/svg' width={17} height={17} viewBox='0 -960 960 960' {...props}>
			<path
				fill='currentColor'
				d='M200-160q-33 0-56.5-23.5T120-240v-560q0-33 23.5-56.5T200-880h560q33 0 56.5 23.5T840-800v226q-19-9-39-14.5t-41-8.5v-203H200v360h168q9 27 30 47t47 28q-3 20-4 40.5t2 40.5q-36-7-67.5-26.5T320-360H200v120h253q7 22 16 42t22 38H200Zm0-80h253-253Zm481 120-12-60q-12-5-22.5-10.5T625-204l-58 18-40-68 46-40q-2-12-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T669-460l12-60h80l12 60q12 5 22.5 10.5T817-436l58-18 40 68-46 40q2 12 2 26t-2 26l46 40-40 68-58-18q-11 8-21.5 13.5T773-180l-12 60h-80Zm40-120q33 0 56.5-23.5T801-320q0-33-23.5-56.5T721-400q-33 0-56.5 23.5T641-320q0 33 23.5 56.5T721-240Z'
			/>
		</svg>
	),
	Import: (props?: SVGIconProps) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props?.size ?? 24}
			height={props?.size ?? 24}
			fill='currentColor'
			viewBox='0 -960 960 960'
			{...props}
		>
			<path d='M160-120v-720h640v400H240v80h200v80H240v80h200v80H160Zm456 0L504-232l56-56 56 56 142-142 56 56-198 198ZM240-520h200v-80H240v80Zm280 0h200v-80H520v80ZM240-680h200v-80H240v80Zm280 0h200v-80H520v80Z' />
		</svg>
	),
	Settings: (props: SVGIconProps) => (
		<SVGIcon {...props}>
			<path d='M8.0768 17.9167L7.75951 15.3781C7.53631 15.3034 7.30742 15.1988 7.07284 15.0642C6.83839 14.9295 6.62874 14.7852 6.44388 14.6315L4.09284 15.625L2.16992 12.2917L4.20346 10.7548C4.1843 10.6309 4.17069 10.5065 4.16263 10.3815C4.15457 10.2565 4.15055 10.132 4.15055 10.0079C4.15055 9.88945 4.15457 9.76904 4.16263 9.64668C4.17069 9.52432 4.1843 9.3905 4.20346 9.24522L2.16992 7.70834L4.09284 4.39105L6.43576 5.37668C6.63673 5.21751 6.85124 5.07195 7.0793 4.94001C7.30735 4.80807 7.53145 4.70202 7.75159 4.62188L8.0768 2.08334H11.923L12.2403 4.6298C12.4903 4.72063 12.7165 4.82668 12.9189 4.94793C13.1214 5.06918 13.3258 5.21209 13.532 5.37668L15.907 4.39105L17.8299 7.70834L15.7643 9.26918C15.7942 9.40376 15.8105 9.52959 15.8133 9.64668C15.8159 9.76362 15.8172 9.8814 15.8172 10C15.8172 10.1132 15.8145 10.2283 15.8091 10.3454C15.8038 10.4624 15.7846 10.5962 15.7516 10.7469L17.8012 12.2917L15.878 15.625L13.532 14.6233C13.3258 14.7879 13.1153 14.9335 12.9005 15.06C12.6858 15.1867 12.4658 15.2901 12.2403 15.3702L11.923 17.9167H8.0768ZM9.16659 16.6667H10.8045L11.1041 14.4344C11.5294 14.3233 11.918 14.1654 12.2699 13.9608C12.622 13.7561 12.9615 13.493 13.2885 13.1715L15.3589 14.0417L16.1795 12.625L14.3718 11.2629C14.4412 11.0471 14.4885 10.8355 14.5135 10.6281C14.5386 10.4209 14.5512 10.2115 14.5512 10C14.5512 9.78307 14.5386 9.57369 14.5135 9.37189C14.4885 9.16994 14.4412 8.96369 14.3718 8.75314L16.1953 7.37501L15.3749 5.95834L13.2803 6.84126C13.0015 6.5432 12.6674 6.27987 12.278 6.05126C11.8886 5.82265 11.4946 5.66077 11.0962 5.56564L10.8333 3.33334H9.17951L8.90367 5.55772C8.47853 5.65814 8.08596 5.81195 7.72596 6.01918C7.36583 6.22654 7.02228 6.49362 6.69534 6.82043L4.62492 5.95834L3.80451 7.37501L5.60409 8.71626C5.53464 8.91404 5.48603 9.11973 5.45826 9.33334C5.43048 9.54695 5.41659 9.77182 5.41659 10.0079C5.41659 10.2249 5.43048 10.4375 5.45826 10.6458C5.48603 10.8542 5.53201 11.0599 5.59617 11.2629L3.80451 12.625L4.62492 14.0417L6.68742 13.1667C7.00367 13.4914 7.3418 13.7574 7.7018 13.9648C8.06194 14.172 8.45992 14.3312 8.89576 14.4423L9.16659 16.6667ZM10.0095 12.5C10.7028 12.5 11.2928 12.2567 11.7795 11.77C12.2662 11.2833 12.5095 10.6933 12.5095 10C12.5095 9.30668 12.2662 8.71668 11.7795 8.23001C11.2928 7.74334 10.7028 7.50001 10.0095 7.50001C9.30756 7.50001 8.71541 7.74334 8.23305 8.23001C7.75069 8.71668 7.50951 9.30668 7.50951 10C7.50951 10.6933 7.75069 11.2833 8.23305 11.77C8.71541 12.2567 9.30756 12.5 10.0095 12.5Z' />
		</SVGIcon>
	),
	Inbox2: (props?: SVGIconProps) => (
		<SVGIcon {...props}>
			<path d='M2.91602 17.0833V2.91663H17.0827V17.0833H2.91602ZM4.16602 15.8333H15.8327V13.1731H13.0923C12.7291 13.7009 12.278 14.1106 11.7389 14.4023C11.1999 14.6939 10.62 14.8398 9.99935 14.8398C9.37865 14.8398 8.79879 14.6939 8.25977 14.4023C7.72074 14.1106 7.26963 13.7009 6.90643 13.1731H4.16602V15.8333ZM9.99935 13.5898C10.5271 13.5898 11.0063 13.437 11.4368 13.1314C11.8674 12.8259 12.166 12.4231 12.3327 11.9231H15.8327V4.16663H4.16602V11.9231H7.66602C7.83268 12.4231 8.13129 12.8259 8.56185 13.1314C8.9924 13.437 9.47157 13.5898 9.99935 13.5898Z' />
		</SVGIcon>
	),
	Decimals: ({ className, size = 24, ...props }: React.SVGProps<SVGSVGElement> & { size?: number | string }) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height={size}
			viewBox='0 -960 960 960'
			width={size}
			fill='currentColor'
			className={className}
			{...props}
		>
			<path d='m720-80-56-56 63-64H480v-80h247l-63-64 56-56 160 160L720-80ZM80-440v-120h120v120H80Zm300 0q-58 0-99-41t-41-99v-160q0-58 41-99t99-41q58 0 99 41t41 99v160q0 58-41 99t-99 41Zm360 0q-58 0-99-41t-41-99v-160q0-58 41-99t99-41q58 0 99 41t41 99v160q0 58-41 99t-99 41Zm-360-80q25 0 42.5-17.5T440-580v-160q0-25-17.5-42.5T380-800q-25 0-42.5 17.5T320-740v160q0 25 17.5 42.5T380-520Zm360 0q25 0 42.5-17.5T800-580v-160q0-25-17.5-42.5T740-800q-25 0-42.5 17.5T680-740v160q0 25 17.5 42.5T740-520Z' />
		</svg>
	),
	Check: (props?: SVGIconProps) => (
		<SVGIcon {...props}>
			<path fill='currentColor' d='m14 5.167-8 8L2.333 9.5l.94-.94L6 11.28l7.06-7.053.94.94Z' />
		</SVGIcon>
	),
	AlertCircle: (props?: SVGIconProps) => (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={17} viewBox='0 0 16 17' fill='none' {...props}>
			<path
				fill='currentColor'
				d='M7.333 10.5h1.334v1.333H7.334V10.5Zm0-5.333h1.334v4H7.334v-4ZM8 1.833c-3.686 0-6.667 3-6.667 6.667A6.667 6.667 0 1 0 8 1.833Zm0 12A5.333 5.333 0 1 1 8 3.167a5.333 5.333 0 0 1 0 10.666Z'
			/>
		</svg>
	),
	Transactions2: (props?: SVGIconProps) => (
		<svg xmlns='http://www.w3.org/2000/svg' width={40} height={40} fill='none' {...props}>
			<path
				fill='currentColor'
				d='M23.333 16.667H5V20h18.333v-3.333Zm0-6.667H5v3.333h18.333V10ZM5 26.667h11.667v-3.334H5v3.334Zm19 10 4.333-4.334 4.334 4.334L35 34.333 30.667 30 35 25.667l-2.333-2.334-4.334 4.334L24 23.333l-2.333 2.334L26 30l-4.333 4.333L24 36.667Z'
			/>
		</svg>
	),
	Info: (props?: SVGIconProps) => (
		<svg xmlns='http://www.w3.org/2000/svg' width={14} height={14} fill='none' {...props}>
			<path
				fill='currentColor'
				d='M6.333 5h1.333V3.667H6.333M7 12.333A5.34 5.34 0 0 1 1.666 7 5.34 5.34 0 0 1 7 1.667 5.34 5.34 0 0 1 12.333 7 5.34 5.34 0 0 1 7 12.333Zm0-12a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 7 .333Zm-.667 10h1.333v-4H6.333v4Z'
			/>
		</svg>
	),
	Github: (props: SVGIconProps) => (
		<SVGIcon {...props} viewBox='0 0 22 22' fill='none'>
			<path
				fill='currentColor'
				fillRule='evenodd'
				d='M11.21.22C5.412.22.71 5.038.71 10.984c0 4.757 3.009 8.792 7.18 10.216.525.1.718-.234.718-.518 0-.257-.01-1.105-.014-2.005-2.921.652-3.538-1.27-3.538-1.27-.477-1.244-1.165-1.575-1.165-1.575-.953-.668.071-.655.071-.655 1.055.076 1.61 1.11 1.61 1.11.936 1.646 2.456 1.17 3.056.895.094-.696.366-1.171.666-1.44-2.332-.272-4.784-1.195-4.784-5.32 0-1.176.41-2.136 1.082-2.89-.109-.271-.468-1.366.102-2.85 0 0 .882-.288 2.888 1.105a9.833 9.833 0 0 1 2.628-.363 9.857 9.857 0 0 1 2.63.363c2.005-1.393 2.885-1.104 2.885-1.104.572 1.483.212 2.578.103 2.849.674.754 1.08 1.714 1.08 2.89 0 4.135-2.455 5.045-4.794 5.312.377.334.712.989.712 1.993 0 1.44-.011 2.6-.011 2.955 0 .286.188.622.72.516 4.17-1.425 7.175-5.459 7.175-10.214 0-5.946-4.7-10.766-10.5-10.766Z'
				clipRule='evenodd'
			/>
			<path
				fill='currentColor'
				d='M4.687 15.677c-.023.053-.105.07-.18.033-.076-.036-.119-.109-.094-.162.023-.055.105-.07.18-.034.077.035.12.109.094.163Zm.425.486c-.05.047-.148.025-.214-.05-.069-.075-.082-.176-.03-.224.05-.047.146-.025.214.05.07.076.083.176.03.224Zm.414.62c-.064.046-.17.003-.234-.093-.065-.096-.065-.21.001-.257.065-.046.17-.004.235.09.064.098.064.213-.002.26Zm.568.599c-.058.065-.18.047-.27-.041-.092-.087-.117-.21-.06-.275.058-.066.182-.047.272.04.091.087.119.211.058.276Zm.782.348c-.026.084-.143.122-.262.087-.12-.037-.197-.136-.173-.221.025-.085.143-.125.263-.087.119.037.197.135.172.22Zm.86.064c.002.09-.098.163-.223.164-.126.003-.228-.069-.229-.156 0-.09.099-.162.224-.165.125-.002.228.07.228.157Zm.799-.139c.015.086-.072.175-.196.199-.122.023-.235-.03-.25-.116-.015-.09.073-.178.195-.201.124-.022.235.03.25.118Z'
			/>
		</SVGIcon>
	),
	Sidebar: (props?: SVGIconProps) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={24}
			height={24}
			fill='currentColor'
			viewBox='0 -960 960 960'
			{...props}
		>
			<path d='M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm240-80h400v-480H400v480Zm-80 0v-480H160v480h160Zm-160 0v-480 480Zm160 0h80-80Zm0-480h80-80Z' />
		</svg>
	),
	SidebarFilled: (props?: SVGIconProps) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={24}
			height={24}
			fill='currentColor'
			viewBox='0 -960 960 960'
			{...props}
		>
			<path d='M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h160v640H160Zm240 0v-640h400q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H400Z' />
		</svg>
	),
	Reconnect: (props?: SVGIconProps) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props?.size}
			height={props?.size}
			fill='currentColor'
			viewBox='0 -960 960 960'
			{...props}
		>
			<path d='M760-120q-39 0-70-22.5T647-200H440q-66 0-113-47t-47-113q0-66 47-113t113-47h80q33 0 56.5-23.5T600-600q0-33-23.5-56.5T520-680H313q-13 35-43.5 57.5T200-600q-50 0-85-35t-35-85q0-50 35-85t85-35q39 0 69.5 22.5T313-760h207q66 0 113 47t47 113q0 66-47 113t-113 47h-80q-33 0-56.5 23.5T360-360q0 33 23.5 56.5T440-280h207q13-35 43.5-57.5T760-360q50 0 85 35t35 85q0 50-35 85t-85 35ZM200-680q17 0 28.5-11.5T240-720q0-17-11.5-28.5T200-760q-17 0-28.5 11.5T160-720q0 17 11.5 28.5T200-680Z' />
		</svg>
	),
	DotRaster: (props?: SVGIconProps) => (
		<svg xmlns='http://www.w3.org/2000/svg' width={8} height={8} fill='none' {...props}>
			<mask
				id='a'
				width={8}
				height={8}
				x={0}
				y={0}
				maskUnits='userSpaceOnUse'
				style={{
					maskType: 'alpha',
				}}
			>
				<circle cx={4} cy={4} r={4} fill='#D9D9D9' />
			</mask>
			<g fill='currentColor' mask='url(#a)'>
				<path d='m4.58-1.398.717.698-6.28 6.447-.717-.698zM7.27-.072l.716.698L.45 8.363l-.716-.698zM9.962 1.255l.717.698-8.045 8.258-.717-.698z' />
			</g>
		</svg>
	),
	Gmail: (props?: SVGIconProps) => (
		<svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} viewBox='0 0 48 48' {...props}>
			<path fill='#4caf50' d='m45 16.2-5 2.75-5 4.75V40h7a3 3 0 0 0 3-3V16.2z' />
			<path fill='#1e88e5' d='m3 16.2 3.614 1.71L13 23.7V40H6a3 3 0 0 1-3-3V16.2z' />
			<path fill='#e53935' d='m35 11.2-11 8.25-11-8.25-1 5.8 1 6.7 11 8.25 11-8.25 1-6.7z' />
			<path fill='#c62828' d='M3 12.298V16.2l10 7.5V11.2L9.876 8.859A4.298 4.298 0 0 0 3 12.298z' />
			<path fill='#fbc02d' d='M45 12.298V16.2l-10 7.5V11.2l3.124-2.341A4.298 4.298 0 0 1 45 12.298z' />
		</svg>
	),
	Outlook: (props?: SVGIconProps) => (
		<svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} viewBox='0 0 48 48' {...props}>
			<path
				fill='#40c4ff'
				d='M31.323,8.502L7.075,23.872l-2.085-3.29v-2.835c0-1.032,0.523-1.994,1.389-2.556l14.095-9.146c2.147-1.393,4.914-1.394,7.061-0.001L31.323,8.502z'
			/>
			<path
				fill='#1976d2'
				d='M27.317,5.911c0.073,0.043,0.145,0.088,0.217,0.135l11,7.136L11.259,30.47l-4.185-6.603l20.017-12.713C28.988,9.95,29.071,7.241,27.317,5.911z'
			/>
			<path
				fill='#0d47a1'
				d='M22.142,33.771L11.26,30.47l23.136-14.666c1.949-1.235,1.944-4.08-0.009-5.308l-0.104-0.065l0.3,0.186l7.041,4.568c0.866,0.562,1.389,1.524,1.389,2.556v2.744L22.142,33.771z'
			/>
			<path
				fill='#29b6f6'
				d='M20.886,43h15.523c3.646,0,6.602-2.956,6.602-6.602V17.797c0,1.077-0.554,2.079-1.466,2.652l-23.09,14.498c-1.246,0.782-2.001,2.15-2.001,3.62C16.454,41.016,18.438,43,20.886,43z'
			/>
			<path
				fill='#80d8ff'
				d='M27.198,42.999H11.589c-3.646,0-6.602-2.956-6.602-6.602V17.783c0,1.076,0.552,2.076,1.461,2.649l23.067,14.543c1.263,0.796,2.029,2.185,2.029,3.678C31.544,41.053,29.598,42.999,27.198,42.999z'
			/>
			<path
				fill='#1565c0'
				d='M6.453,23h10.094C18.454,23,20,24.546,20,26.453v10.094C20,38.454,18.454,40,16.547,40H6.453C4.546,40,3,38.454,3,36.547V26.453C3,24.546,4.546,23,6.453,23z'
			/>
			<path
				fill='#fff'
				d='M11.453,36.518c-1.4,0-2.55-0.452-3.449-1.355c-0.899-0.903-1.348-2.082-1.348-3.537c0-1.536,0.456-2.778,1.369-3.726c0.913-0.949,2.107-1.423,3.584-1.423c1.396,0,2.532,0.454,3.408,1.362c0.881,0.908,1.321,2.105,1.321,3.591c0,1.527-0.456,2.758-1.369,3.692C14.061,36.053,12.889,36.518,11.453,36.518z M11.493,34.601c0.763,0,1.378-0.269,1.843-0.806c0.465-0.538,0.698-1.285,0.698-2.243c0-0.998-0.226-1.775-0.677-2.331c-0.452-0.556-1.055-0.833-1.809-0.833c-0.777,0-1.403,0.287-1.877,0.861c-0.474,0.569-0.711,1.323-0.711,2.263c0,0.953,0.237,1.707,0.711,2.263C10.145,34.326,10.752,34.601,11.493,34.601z'
			/>
		</svg>
	),
	Slack: (props: SVGIconProps) => (
		<SVGIcon {...props} size={24} viewBox='75 75 125 125' fill='none'>
			<g>
				<g>
					<path
						fill='#E01E5A'
						d='M99.4,151.2c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h12.9V151.2z'
					/>
					<path
						fill='#E01E5A'
						d='M105.9,151.2c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v32.3c0,7.1-5.8,12.9-12.9,12.9
			s-12.9-5.8-12.9-12.9V151.2z'
					/>
				</g>
				<g>
					<path
						fill='#36C5F0'
						d='M118.8,99.4c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v12.9H118.8z'
					/>
					<path
						fill='#36C5F0'
						d='M118.8,105.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9H86.5c-7.1,0-12.9-5.8-12.9-12.9
			s5.8-12.9,12.9-12.9H118.8z'
					/>
				</g>
				<g>
					<path
						fill='#2EB67D'
						d='M170.6,118.8c0-7.1,5.8-12.9,12.9-12.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9h-12.9V118.8z'
					/>
					<path
						fill='#2EB67D'
						d='M164.1,118.8c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9V86.5c0-7.1,5.8-12.9,12.9-12.9
			c7.1,0,12.9,5.8,12.9,12.9V118.8z'
					/>
				</g>
				<g>
					<path
						fill='#ECB22E'
						d='M151.2,170.6c7.1,0,12.9,5.8,12.9,12.9c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9v-12.9H151.2z'
					/>
					<path
						fill='#ECB22E'
						d='M151.2,164.1c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h32.3c7.1,0,12.9,5.8,12.9,12.9
			c0,7.1-5.8,12.9-12.9,12.9H151.2z'
					/>
				</g>
			</g>
		</SVGIcon>
	),
	CreateTransaction: (props?: SVGIconProps) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props?.size ?? 24}
			height={props?.size ?? 24}
			fill='currentColor'
			viewBox='0 -960 960 960'
			{...props}
		>
			<path d='M640-121v-120H520v-80h120v-120h80v120h120v80H720v120h-80ZM160-240v-80h283q-3 21-2.5 40t3.5 40H160Zm0-160v-80h386q-23 16-41.5 36T472-400H160Zm0-160v-80h600v80H160Zm0-160v-80h600v80H160Z' />
		</svg>
	),
	ArrowCoolDown: (props?: SVGIconProps) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={24}
			height={24}
			fill='currentColor'
			viewBox='0 -960 960 960'
			{...props}
		>
			<path d='M480-80 200-360l56-57 184 184v-287h80v287l184-183 56 56L480-80Zm-40-520v-120h80v120h-80Zm0-200v-80h80v80h-80Z' />
		</svg>
	),
	Delete: ({ size = 24, ...props }: { size?: number } & React.SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={size}
			height={size}
			fill='currentColor'
			viewBox='0 -960 960 960'
			{...props}
		>
			<path d='M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z' />
		</svg>
	),
	Tracker: (props: SVGIconProps) => (
		<SVGIcon {...props}>
			<path d='M7.65956 2.29166V1.04166H12.3391V2.29166H7.65956ZM9.37435 11.5064H10.6243V6.82686H9.37435V11.5064ZM9.99935 17.9167C9.02504 17.9167 8.10838 17.7308 7.24935 17.3589C6.39032 16.9871 5.63928 16.4796 4.99622 15.8364C4.35303 15.1934 3.84553 14.4424 3.47372 13.5833C3.10192 12.7243 2.91602 11.8076 2.91602 10.8333C2.91602 9.85902 3.10192 8.94235 3.47372 8.08332C3.84553 7.2243 4.35303 6.47325 4.99622 5.8302C5.63928 5.187 6.39032 4.6795 7.24935 4.3077C8.10838 3.93589 9.02504 3.74999 9.99935 3.74999C10.8338 3.74999 11.6375 3.89159 12.4104 4.17478C13.1833 4.45784 13.901 4.86325 14.5635 5.39103L15.6018 4.3527L16.48 5.23082L15.4416 6.26916C15.9694 6.93166 16.3748 7.64936 16.6579 8.42228C16.9411 9.1952 17.0827 9.99888 17.0827 10.8333C17.0827 11.8076 16.8968 12.7243 16.525 13.5833C16.1532 14.4424 15.6457 15.1934 15.0025 15.8364C14.3594 16.4796 13.6084 16.9871 12.7493 17.3589C11.8903 17.7308 10.9737 17.9167 9.99935 17.9167ZM9.99935 16.6667C11.6105 16.6667 12.9855 16.0972 14.1243 14.9583C15.2632 13.8194 15.8327 12.4444 15.8327 10.8333C15.8327 9.22221 15.2632 7.84721 14.1243 6.70832C12.9855 5.56943 11.6105 4.99999 9.99935 4.99999C8.38824 4.99999 7.01324 5.56943 5.87435 6.70832C4.73546 7.84721 4.16602 9.22221 4.16602 10.8333C4.16602 12.4444 4.73546 13.8194 5.87435 14.9583C7.01324 16.0972 8.38824 16.6667 9.99935 16.6667Z' />
		</SVGIcon>
	),
	ExpandContent: (props: SVGIconProps) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={24}
			height={24}
			fill='currentColor'
			viewBox='0 -960 960 960'
			{...props}
		>
			<path d='M200-200v-240h80v160h160v80H200Zm480-320v-160H520v-80h240v240h-80Z' />
		</svg>
	),
	Overview: MdOutlineWidgets,
	Inbox: ArchiveIcon,
	Close: MdClose,
	X: (props: SVGIconProps) => (
		<SVGIcon {...props} viewBox='0 0 24 24' fill='currentColor'>
			<path d='M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z' />
		</SVGIcon>
	),
	Discord: PiDiscordLogo,
	PdfOutline: MdOutlinePictureAsPdf,
	Amount: MdOutlineEqualizer,
	Attachments: MdOutlineAttachFile,
	GithubOutline: FiGithub,
	Refresh: MdRefresh,
	Currency: MdAttachMoney,
	Inventory2: MdInventory2,
	Notifications: MdOutlineNotificationsNone,
	ChevronDown: MdExpandMore,
	ChevronUp: MdExpandLess,
	TrendingUp: MdTrendingUp,
	TrendingDown: MdTrendingDown,
	Category: MdOutlineCategory,
	Visibility: MdOutlineVisibility,
	Face: MdOutlineFace,
	MoreHoriz: MdMoreHoriz,
	Pdf: MdPictureAsPdf,
	BrokenImage: MdOutlineBrokenImage,
	Description: MdDescription,
	FolderZip: MdFolderZip,
	ChevronRight: MdChevronRight,
	ChevronLeft: MdChevronLeft,
	ArrowBack: MdArrowBack,
	ArrowForward: MdArrowForward,
	Folder: MdFolder,
	Search: MdSearch,
	Error: MdErrorOutline,
	AI: MdAutoAwesome,
	AIOutline: MdOutlineAutoAwesome,
	Insights: MdOutlineInsights,
	Time: MdOutlineMoreTime,
	Add: MdOutlineAdd,
	Copy: MdOutlineContentCopy,
	Share: MdIosShare,
	Play: MdPlayArrow,
	Stop: MdStop,
	StopOutline: MdOutlineStop,
	PlayOutline: MdOutlinePlayArrow,
	MoreVertical: MdOutlineMoreVert,
	Match: MdOutlineTask,
	History: MdOutlineHistory,
	Email: MdOutlineEmail,
	Tune: MdOutlineTune,
	Change: MdChangeHistory,
	CalendarMonth: MdOutlineCalendarMonth,
	Sort: MdSort,
	Palette: MdOutlinePalette,
	Menu: MdMenu,
	Mute: MdOutlineVolumeOff,
	UnMute: MdOutlineVolumeUp,
	Clear: MdOutlineClear,
	Filter: MdOutlineFilterList,
	Status: MdOutlineStyle,
	Accounts: MdOutlineAccountBalance,
	ArrowRightAlt: MdArrowRightAlt,
	AccountCircle: MdOutlineAccountCircle,
	Repeat: MdOutlineRepeat,
	ProjectStatus: MdDownloading,
	Edit: MdOutlineEditNote,
	OpenInNew: MdOutlineOpenInNew,
	DragIndicator: MdDragIndicator,
	ExternalLink: MdOutlineLaunch,
	Link: MdOutlineLink,
	AddLink: MdOutlineAddLink,
	CropFree: MdOutlineCropFree,
	DateFormat: MdOutlineFactCheck,
	Tax: MdOutlineAssuredWorkload,
	Vat: MdOutlineCalculate,
	CurrencyOutline: MdOutlineAttachMoney,
	SnippetFolder: MdSnippetFolder,
	ConfirmationNumber: MdOutlineConfirmationNumber,
	QrCode: MdOutlineQrCode2,
	ArrowOutward: MdOutlineArrowOutward,
	Straighten: MdOutlineSquareFoot,
	Files: MdOutlineInventory2,
	GridView: MdOutlineGridView,
	ListView: MdOutlineReorder,
	ArrowDownward: MdArrowDownward,
	ArrowUpward: MdArrowUpward,
	SubdirectoryArrowLeft: MdOutlineSubdirectoryArrowLeft,
	OutgoingMail: MdOutlineSignpost,
	AttachEmail: MdOutlineAttachEmail,
	ForwardToInbox: MdOutlineForwardToInbox,
	SyncAlt: MdOutlineSyncAlt,
	InfoOutline: MdOutlineInfo,
	DashboardCustomize: MdOutlineDashboardCustomize,
	ThumbUp: MdOutlineThumbUp,
	ThumbDown: MdOutlineThumbDown,
	ThumbUpOutline: MdOutlineThumbUp,
	ThumbDownOutline: MdOutlineThumbDown,
	RefreshOutline: MdOutlineRefresh,
	Globle: MdOutlineLanguage,
	Record: MdOutlineGraphicEq,
	Speed: MdOutlineStackedBarChart,
	ReceiptLong: MdOutlineReceiptLong,
	Bolt: MdBolt,
	Star: MdOutlineStar,
	ShowChart: MdOutlineShowChart,
	Leaderboard: MdOutlineLeaderboard,
	Monitoring: (props: SVGIconProps) => (
		<SVGIcon {...props} viewBox='0 -960 960 960' strokeWidth={0}>
			<path d='M120-120v-80l80-80v160h-80Zm160 0v-240l80-80v320h-80Zm160 0v-320l80 81v239h-80Zm160 0v-239l80-80v319h-80Zm160 0v-400l80-80v480h-80ZM120-327v-113l280-280 160 160 280-280v113L560-447 400-607 120-327Z' />
		</SVGIcon>
	),
	PieChart: MdOutlinePieChart,
	ArrowDropDown: MdArrowDropDown,
	Block: MdOutlineBlock,
	ListAlt: MdOutlineListAlt,
	LightMode: MdOutlineLightMode,
	DarkMode: MdOutlineDarkMode,
	WhatsApp: (props: SVGIconProps) => (
		<SVGIcon {...props} viewBox='0 0 24 24'>
			<path d='M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z' />
		</SVGIcon>
	),
	IMessage: (props: SVGIconProps) => (
		<SVGIcon {...props} viewBox='0 0 24 24' fill='none' strokeWidth={0}>
			<path
				fill='#34C759'
				d='M12 20.5c5.799 0 10.5-4.03 10.5-9s-4.701-9-10.5-9s-10.5 4.03-10.5 9c0 3.13 1.865 5.888 4.694 7.5c0 1.412-1.694 3-1.694 3c1.211.136 3.87-.034 4.817-1.797c.856.194 1.756.297 2.683.297Z'
			/>
		</SVGIcon>
	),
	Telegram: ({ className, ...props }: SVGIconProps) => (
		<svg
			className={className}
			width={props.size ?? 20}
			height={props.size ?? 20}
			viewBox='0 0 240 240'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<circle cx='120' cy='120' r='120' fill='#229ED9' />
			<path
				d='M54.3 118.8c35-15.3 58.3-25.3 69.7-30.2 32.5-13.5 39.3-15.8 43.7-15.9 1 0 3.1.2 4.6 1.4 1.2 1 1.6 2.3 1.8 3.2.2 1 .4 3.2.2 4.9-2.1 19.8-10.1 67.8-14.2 89.9-1.8 9.3-5.2 12.5-8.6 12.8-7.3.7-12.9-4.8-19.9-9.4-11-7.2-17.2-11.7-27.8-18.7-12.2-8.1-4.3-12.5 2.7-19.8 1.8-1.9 33.2-30.4 33.8-33 .1-.3.1-1.6-.7-2.3s-2-.4-2.8-.2c-1.2.3-20 12.7-56.5 37.1-5.3 3.6-10.2 5.3-14.6 5.2-4.8-.1-14.1-2.7-21.1-4.9-8.5-2.8-15.2-4.2-14.6-8.9.3-2.4 3.7-4.8 10-7.3Z'
				fill='white'
			/>
		</svg>
	),
	LinkedIn: (props: SVGIconProps) => (
		<SVGIcon {...props} viewBox='0 0 72 72'>
			<rect width='72' height='72' rx='8' fill='#0077B7' />
			<path
				fill='#fff'
				d='M20.5 29h8v28.5h-8zM24.5 17c2.7 0 4.9 2.2 4.9 4.9s-2.2 4.9-4.9 4.9-4.9-2.2-4.9-4.9 2.2-4.9 4.9-4.9M33.5 29h7.7v3.9h.1c1.1-2 3.7-4.1 7.6-4.1 8.1 0 9.6 5.3 9.6 12.3v14.4h-8V43.2c0-3.4-.1-7.8-4.8-7.8-4.8 0-5.5 3.7-5.5 7.6v14.5h-8V29z'
			/>
		</SVGIcon>
	),
	Instagram: (props: SVGIconProps) => (
		<SVGIcon {...props} viewBox='0 0 24 24'>
			<defs>
				<linearGradient id='instagram-gradient' x1='0%' y1='100%' x2='100%' y2='0%'>
					<stop offset='0%' stopColor='#FEDA77' />
					<stop offset='25%' stopColor='#FA7E1E' />
					<stop offset='50%' stopColor='#D62976' />
					<stop offset='75%' stopColor='#962FBF' />
					<stop offset='100%' stopColor='#4F5BD5' />
				</linearGradient>
			</defs>
			<rect width='24' height='24' rx='6' fill='url(#instagram-gradient)' />
			<rect x='4' y='4' width='16' height='16' rx='4' stroke='#fff' strokeWidth='2' fill='none' />
			<circle cx='12' cy='12' r='3.5' stroke='#fff' strokeWidth='2' fill='none' />
			<circle cx='17' cy='7' r='1.5' fill='#fff' />
		</SVGIcon>
	),
	Facebook: (props: SVGIconProps) => (
		<SVGIcon {...props} viewBox='0 0 24 24'>
			<circle cx='12' cy='12' r='12' fill='#1877F2' />
			<path
				fill='#fff'
				d='M16.671 15.469l.547-3.469h-3.343v-2.25c0-.949.478-1.875 2.016-1.875h1.559V5.156S16.045 5 14.703 5c-2.804 0-4.637 1.653-4.637 4.641V12H7.078v3.469h2.988v8.385a12.158 12.158 0 003.672 0v-8.385h2.933z'
			/>
		</SVGIcon>
	),
	Xero: ({ className }: { className?: string }) => (
		<svg className={className} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M20 40C31.0456 40 40 31.0456 40 20C40 8.95437 31.0456 0 20 0C8.95437 0 0 8.95437 0 20C0 31.0456 8.95437 40 20 40Z'
				fill='#13B5EA'
			/>
			<path
				d='M9.61353 19.9424L13.0137 16.5339C13.1264 16.419 13.1893 16.2669 13.1893 16.1055C13.1893 15.7693 12.916 15.4963 12.5798 15.4963C12.416 15.4963 12.2625 15.5605 12.1467 15.6777L8.74963 19.0732L5.33735 15.6726C5.22205 15.5589 5.06927 15.4963 4.90727 15.4963C4.57147 15.4963 4.2981 15.7692 4.2981 16.1051C4.2981 16.2689 4.36351 16.4226 4.48091 16.5385L7.88058 19.9377L4.48267 23.342C4.36324 23.4596 4.2981 23.6136 4.2981 23.7782C4.2981 24.1143 4.57147 24.387 4.90727 24.387C5.06954 24.387 5.22246 24.3241 5.33735 24.2091L8.74435 20.8067L12.1384 24.1967C12.2588 24.3212 12.4141 24.3874 12.5798 24.3874C12.9157 24.3874 13.189 24.1143 13.189 23.7782C13.189 23.616 13.1261 23.4636 13.0118 23.3487L9.61353 19.9424Z'
				fill='white'
			/>
			<path
				d='M29.8268 19.9414C29.8268 20.5519 30.3232 21.0484 30.9344 21.0484C31.5441 21.0484 32.0407 20.5519 32.0407 19.9414C32.0407 19.3308 31.5441 18.8343 30.9344 18.8343C30.3232 18.8343 29.8268 19.3308 29.8268 19.9414Z'
				fill='white'
			/>
			<path
				d='M27.7271 19.9419C27.7271 18.1741 29.1652 16.7358 30.9332 16.7358C32.7003 16.7358 34.1388 18.1741 34.1388 19.9419C34.1388 21.7093 32.7003 23.1471 30.9332 23.1471C29.1652 23.1471 27.7271 21.7093 27.7271 19.9419ZM26.4659 19.9419C26.4659 22.4048 28.47 24.4085 30.9332 24.4085C33.3964 24.4085 35.4014 22.4048 35.4014 19.9419C35.4014 17.4788 33.3964 15.4745 30.9332 15.4745C28.47 15.4745 26.4659 17.4788 26.4659 19.9419Z'
				fill='white'
			/>
			<path
				d='M26.1489 15.5509L25.9614 15.5503C25.3988 15.5503 24.8561 15.7278 24.4028 16.0771C24.3431 15.8038 24.0988 15.5981 23.8078 15.5981C23.4729 15.5981 23.2045 15.8665 23.2037 16.2021V23.726C23.2066 24.061 23.4799 24.3333 23.815 24.3333C24.1501 24.3333 24.4232 24.061 24.4241 23.7253V19.099C24.4244 17.5571 24.5654 16.9343 25.8862 16.7693C26.0083 16.7541 26.1411 16.7565 26.1416 16.7565C26.503 16.7441 26.7599 16.4957 26.7599 16.16C26.7599 15.8242 26.4857 15.5509 26.1489 15.5509Z'
				fill='white'
			/>
			<path
				d='M14.4513 19.2065C14.4525 19.1725 14.4534 19.1553 14.4534 19.1553C14.807 17.7571 16.0733 16.7225 17.5814 16.7225C19.1076 16.7225 20.3855 17.7826 20.7211 19.2065H14.4513ZM21.9686 19.0915C21.7061 17.8485 21.0256 16.8276 19.9894 16.1719C18.4747 15.2103 16.4746 15.2635 15.0116 16.3039C13.8182 17.1529 13.1293 18.5417 13.1293 19.9723C13.1293 20.331 13.1725 20.6931 13.2625 21.0495C13.7132 22.8222 15.2371 24.1641 17.0539 24.3865C17.5931 24.4518 18.1179 24.4205 18.6613 24.2798C19.1282 24.1662 19.5801 23.9768 19.9964 23.71C20.4285 23.4322 20.7895 23.0659 21.1392 22.6275L21.1604 22.6038C21.403 22.3028 21.358 21.8749 21.0914 21.6706C20.8665 21.4982 20.4889 21.4283 20.1918 21.8088C20.128 21.8997 20.0567 21.9933 19.9783 22.0869C19.7421 22.348 19.449 22.6009 19.0978 22.797C18.6509 23.0358 18.1417 23.1722 17.6003 23.1753C15.8283 23.1556 14.88 21.9186 14.5428 21.0358C14.4839 20.8709 14.4384 20.6999 14.4068 20.5238L14.3984 20.4298H20.7573C21.629 20.4105 22.0982 19.7951 21.9686 19.0915Z'
				fill='white'
			/>
		</svg>
	),
	QuickBooks: ({ className }: { className?: string }) => (
		<svg className={className} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M20 40C31.0456 40 40 31.0456 40 20C40 8.95437 31.0456 0 20 0C8.95437 0 0 8.95437 0 20C0 31.0456 8.95437 40 20 40Z'
				fill='#2CA01C'
			/>
			<path
				d='M5.55585 20C5.55585 22.0628 6.3753 24.0411 7.83392 25.4998C9.29255 26.9584 11.2709 27.7778 13.3337 27.7778H14.4446V24.8888H13.3337C12.6884 24.8939 12.0484 24.7713 11.4507 24.5279C10.8531 24.2845 10.3095 23.9252 9.85132 23.4707C9.3932 23.0163 9.02957 22.4756 8.78142 21.8799C8.53328 21.2841 8.40552 20.6452 8.40552 19.9999C8.40552 19.3545 8.53328 18.7156 8.78142 18.1199C9.02957 17.5242 9.3932 16.9835 9.85132 16.529C10.3095 16.0745 10.8531 15.7152 11.4507 15.4718C12.0484 15.2284 12.6884 15.1058 13.3337 15.111H16.0002V30.2222C16.0005 30.9883 16.3049 31.723 16.8466 32.2647C17.3883 32.8064 18.1229 33.1109 18.889 33.1113V12.2222H13.3337C12.3122 12.2222 11.3008 12.4233 10.3571 12.8142C9.41345 13.205 8.55599 13.7779 7.83372 14.5002C7.11145 15.2224 6.53851 16.0798 6.14762 17.0235C5.75673 17.9672 5.55585 18.9786 5.55585 20ZM26.6668 12.2222H25.5559V15.1113H26.6668C27.9538 15.1258 29.1831 15.6473 30.0881 16.5625C30.993 17.4778 31.5006 18.7129 31.5006 20C31.5006 21.2871 30.993 22.5223 30.0881 23.4375C29.1831 24.3527 27.9538 24.8742 26.6668 24.8888H24.0002V9.77815C24.0003 9.39876 23.9256 9.02309 23.7804 8.67257C23.6353 8.32206 23.4225 8.00357 23.1542 7.73529C22.886 7.46701 22.5675 7.2542 22.217 7.10901C21.8665 6.96381 21.4909 6.88908 21.1115 6.88908V27.7781H26.6668C28.7296 27.7781 30.7079 26.9587 32.1665 25.5001C33.6252 24.0415 34.4446 22.0631 34.4446 20.0003C34.4446 17.9375 33.6252 15.9592 32.1665 14.5006C30.7079 13.042 28.7296 12.2222 26.6668 12.2222Z'
				fill='white'
			/>
		</svg>
	),
	Fortnox: ({ className }: { className?: string }) => (
		<svg className={className} viewBox='0 0 1550 1550' xmlns='http://www.w3.org/2000/svg'>
			<path
				fill='#003824'
				d='m774.4 302.8h243.3c17.6 0 27.1 9.5 27.1 27.1v129.8c0 17.5-9.4 26.9-27.1 26.9h-243.3c-56.7 0-94.5 37.9-94.5 94.6v177h337.8c17.6 0 27.1 9.5 27.1 27v129.8c0 17.6-9.4 27.1-27.1 27.1h-337.8v252.6c0 17.6-9.5 27.1-27.1 27.1h-135.1c-17.6 0-27.1-9.4-27.1-27.1v-608.1c0-168.9 114.9-283.9 283.8-283.9'
			/>
			<path
				fill='#007533'
				d='m774.8 1549.9c-148.3 0-294.9-42.5-421.6-124.7-157-101.7-271.7-256.7-323.1-436.3-51-177.8-36.9-367.9 39.6-535.2 12.3-26.8 44-38.6 70.8-26.3 26.7 12.2 38.6 43.9 26.2 70.7-65.9 144.2-78 308.2-34.1 461.5 44.3 154.8 143.3 288.5 278.6 376.2 160.5 104.1 358.5 134.3 543.2 82.8 28.4-7.8 57.8 8.8 65.7 37.1 7.8 28.4-8.8 57.8-37.1 65.6-68.5 19.2-138.5 28.5-208.3 28.5z'
			/>
			<path
				fill='#ffc200'
				d='m1162.9 1436.8c-17.6 0-34.9-8.8-45-24.8-15.8-24.8-8.5-57.8 16.3-73.6 81.1-51.7 148.9-118.8 201.3-199.7 200.5-309.2 112.1-723.8-197-924.3-10.1-6.6-21.2-13.2-34.7-20.9-25.6-14.5-34.7-47-20.1-72.7 14.5-25.6 47-34.7 72.7-20.1 15.5 8.7 28.3 16.4 40.2 24.1 358.5 232.5 460.9 713.4 228.4 1071.9-60.8 93.8-139.4 171.7-233.5 231.6-8.9 5.7-18.8 8.4-28.6 8.4z'
			/>
			<path
				fill='#00db33'
				d='m234 350.8c-12.5 0-25.2-4.3-35.2-13.2-22.2-19.5-24.3-53.2-4.8-75.3 186.3-211.8 473.6-305.2 749.4-243.7 28.8 6.4 46.9 34.9 40.5 63.7-6.4 28.7-34.9 46.8-63.7 40.4-237.9-53-485.5 27.6-646.3 210-10.5 11.9-25.2 18.1-39.9 18.1z'
			/>
		</svg>
	),
} as const

export { Icons }
